import {
  ElementRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { WellSummary } from '@models/well.interface';

@Component({
  selector: 'app-well-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './well-list.component.html',
  styleUrl: './well-list.component.scss'
})
export class WellListComponent implements OnChanges {
  private readonly hostElement = inject(ElementRef<HTMLElement>);
  private readonly locationBusinessUnits = new Set(['goa', 'dwep', 'gom']);

  @Input() wells: WellSummary[] = [];
  @Input() selectedId: number | null = null;
  @Input() newlyCreatedId: number | null = null;

  @Output() wellSelected = new EventEmitter<WellSummary>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['displayName', 'defaultRigName', 'actions'];

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['selectedId'] && !changes['wells']) return;

    setTimeout(() => this.scrollToSelectedRow());
  }
 
  onRowClick(well: WellSummary): void {
    this.wellSelected.emit(well);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onDeleteClick(well: WellSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(well.id);
  }

  private scrollToSelectedRow(): void {
    if (this.selectedId === null) return;

    const row = this.hostElement.nativeElement.querySelector(
      `tr[data-well-id="${this.selectedId}"]`
    ) as HTMLElement | null;

    row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
